import React, { useState } from "react";
// import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { Applogo } from "../../Utils/Images";
import { MdOutlineDashboardCustomize } from "react-icons/md";

import IntlMassage from "../../Utils/IntlMassage";
import useWindowWidth from "../CustomHook/UseWindowWidth";
// import { GoThreeBars } from "react-icons/go";
import "../../Style/global.css";
import { CgCardClubs } from "react-icons/cg";
import { SidebarIconSVG } from "../../Utils/SvgIcons";
import { RiLogoutCircleRLine } from "react-icons/ri";
import { useDispatch } from "react-redux";
import { authlogout } from "../../Store/Authentication";

export default function Sidebar({ dir, open }) {
  const navigate = useNavigate();
  const [type, setType] = useState(false);
  const [width] = useWindowWidth();
  const dispatch = useDispatch();

  const SidebarData = [
    {
      id: "Dashboard",
      path: "/feeds",
      logo: <MdOutlineDashboardCustomize />,
    },
    {
      id: "Categories",
      path: "/categories",
      logo: <CgCardClubs />,
    },
  ];

  const ItemList = () => {
    return SidebarData.map((val) => {
      const active = window.location.pathname === val.path;
      if (active) {
        return (
          <NavIcon onClick={() => navigate(val.path)}>
            {val.logo}
            <p>
              <IntlMassage id={val.id} />
            </p>
          </NavIcon>
        );
      }
      return (
        <NavIcon2 onClick={() => navigate(val.path)}>
          {val.logo}
          <p>
            <IntlMassage id={val.id} />
          </p>
        </NavIcon2>
      );
    });
  };

  const logout = () => {
    dispatch(authlogout());
  };

  const ItemList2 = () => {
    return SidebarData.map((val) => {
      const active = window.location.pathname === val.path;
      if (active) {
        return (
          // <Selecteditem onClick={() => navigate(val.path)}>
          //   <img className="dashImg" src={val.img} alt="" />
          //   {val.Label}
          // </Selecteditem>
          <NavIcon4 onClick={() => navigate(val.path)}>
            {val.logo}
            <p>
              <IntlMassage id={val.id} />
            </p>
          </NavIcon4>
        );
      }
      return (
        <NavIcon3 onClick={() => navigate(val.path)}>
          {val.logo}
          <p>
            <IntlMassage id={val.id} />
          </p>
        </NavIcon3>
      );
    });
  };

  const [isShown, setIsShown] = useState(false);

  const handleClick = (event) => {
    // 👇️ toggle shown state
    setIsShown((current) => !current);

    // 👇️ or simply set it to true
    // setIsShown(true);
  };

  return (
    <>
      {width > 982 ? (
        <SidebarContainer>
          <InnerContainer>
            <div>
              <LogoWrap>
                <h2>Admin Panel</h2>
                {/* <NavLogo src={Applogo}></NavLogo> */}
              </LogoWrap>
              <SidebarMenu>
                <ItemList />
              </SidebarMenu>
            </div>
            <LogoutModal>
              <RiLogoutCircleRLine className="hiddenLogo2" />
              <h3 onClick={logout}>Logout</h3>
            </LogoutModal>
          </InnerContainer>
        </SidebarContainer>
      ) : (
        <>
          <div
            onClick={() => {
              handleClick();
              setType((type) => !type);
            }}
            className="openBtnDiv"
            style={
              type
                ? {
                    width: "26%",
                    display: "flex",
                    justifyContent: "end",
                    zIndex: 9,
                    position: "absolute",
                  }
                : { display: "flex", float: "right" }
            }
          >
            <SidebarIconSVG />
          </div>

          <SidebarContainer>
            <InnerContainer>
              <div>
                <LogoWrap>{/* <h2>Admin Panel</h2> */}</LogoWrap>
                <SidebarMenu>
                  <ItemList />
                </SidebarMenu>
              </div>
              <LogoutModal>
                <RiLogoutCircleRLine className="hiddenLogo2" />
                <h3 onClick={logout}>Logout</h3>
              </LogoutModal>
            </InnerContainer>
          </SidebarContainer>
          {isShown ? (
            <SidebarContainer
              style={{
                position: "fixed",
                width: "23%",
                zIndex: 9,
                transition: "all 2s ease",
              }}
              className="clickOpenDiv"
            >
              {/* <div
                style={{ display: "flex", float: "right" }}
                onClick={handleClick}
              >
                <GoThreeBars style={{ fontSize: "30px" }} />
              </div> */}
              <InnerContainer>
                <div>
                  <LogoWrap>
                    <h2>Admin Panel</h2>
                  </LogoWrap>
                  <SidebarMenu>
                    <ItemList2 />
                  </SidebarMenu>
                </div>
                <LogoutModal>
                  <RiLogoutCircleRLine className="hiddenLogo2" />
                  <h3 onClick={logout}>Logout</h3>
                </LogoutModal>
              </InnerContainer>
            </SidebarContainer>
          ) : (
            ""
          )}
        </>
      )}
    </>
  );
}

const SidebarContainer = styled.div`
  height: 100vh;
  min-height: 550px;
  width: 19%;
  background-color: #252529;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme?.sidebarInnnerDivBg};
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  color: #000;
  position: fixed;
  transition: all ease-out 0.4s;

  @media (max-width: 982px) {
    width: 10%;
  }
`;
const LogoWrap = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 30px;

  h2 {
    font-family: "Poppins";
  }
`;

const SidebarMenu = styled.ul`
  display: flex;
  ${"" /* align-items: center; */}
  flex-direction: column;
  list-style: none;
  width: 100%;
  margin: 0;
  padding: 0;
`;

const InnerContainer = styled.div`
  width: 79%;
  margin: 0 auto;
  padding-top: 40px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
const NavIcon = styled.div`
  padding-left: 20px;
  background: ${({ theme }) => theme?.secondaryColor};
  padding-right: 20px;
  font-size: 20px;
  cursor: pointer;
  line-height: 17px;
  color: ${({ theme }) => theme?.sidebarclickheadingcolor};
  display: flex;
  gap: 10px;
  align-items: center;
  ${"" /* justify-content: center; */}
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 10px;

  @media (max-width: 982px) {
    justify-content: center;
    padding-left: 0px;
    padding-right: 0px;
  }

  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0px;
    font-family: ${({ theme }) => theme?.fontFamily};

    @media (max-width: 982px) {
      display: none;
    }
  }
`;

const NavIcon4 = styled.div`
  padding-left: 20px;
  background: ${({ theme }) => theme?.secondaryColor};
  padding-right: 20px;
  font-size: 20px;
  cursor: pointer;
  line-height: 17px;
  color: ${({ theme }) => theme?.sidebarclickheadingcolor};
  display: flex;
  gap: 10px;
  align-items: center;
  ${"" /* justify-content: center; */}
  padding-top: 15px;
  padding-bottom: 15px;
  border-radius: 10px;

  @media (max-width: 982px) {
    padding-left: 10px;
    padding-right: 0px;
  }

  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0px;
    font-family: ${({ theme }) => theme?.fontFamily};
  }
`;

const NavIcon2 = styled.div`
  padding-left: 20px;
  cursor: pointer;
  padding-right: 20px;
  font-size: 20px;
  line-height: 17px;
  color: ${({ theme }) => theme?.sidebarheadingcolor};
  display: flex;
  gap: 10px;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;

  @media (max-width: 982px) {
    justify-content: center;
    padding-left: 0px;
    padding-right: 0px;
  }

  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0px;
    font-family: ${({ theme }) => theme?.fontFamily};

    @media (max-width: 982px) {
      display: none;
    }
  }
`;

const NavIcon3 = styled.div`
  padding-left: 20px;
  cursor: pointer;
  padding-right: 20px;
  font-size: 20px;
  line-height: 17px;
  color: ${({ theme }) => theme?.sidebarheadingcolor};
  display: flex;
  gap: 10px;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;

  @media (max-width: 982px) {
    padding-left: 10px;
    padding-right: 0px;
  }

  p {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.3;
    margin: 0px;
    font-family: ${({ theme }) => theme?.fontFamily};
  }
`;

const LogoutModal = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  padding-bottom: 20px;

  h3 {
    font-family: "Poppins";
    font-size: 17px;
    cursor: pointer;
    font-weight: 700;
  }

  .hiddenLogo2 {
    font-size: 17px;
    color: #ff0000d6;
  }
`;
